module.exports = __webpack_public_path__ + "static/media/design-wool.6c5ebaf5.svg";